import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
    OrganisationChildFinancialCompany,
    OrganisationChildFinancialCompanyPatch, OrganisationChildFinancialCompanyPost
} from '../models/property-owner/organisation-child-financial-company';
import {ConfigService} from './config.service';
import {DropdownOption} from '../components/dropdown/dropdown-option';
import {ManageOrganisationService} from './manage-organisation.service';
import {BaseEntityStatuses} from "../models/base-entity-statuses";

@Injectable()
export class ChildFinancialCompaniesService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private manageOrganisationService: ManageOrganisationService) {
    }

    getOrganisationChildFinancialCompanies(organisationReference: string, showArchived: boolean = false): Observable<OrganisationChildFinancialCompany[]> {
        let params = new HttpParams();
        params = params.set('showArchived', showArchived ? "true" : "false");
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies`
        return this.http.get<OrganisationChildFinancialCompany[]>(url, { params: params });
    }

    getOrganisationChildFinancialCompany(organisationReference: string, guid: string): Observable<OrganisationChildFinancialCompany> {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies/${guid}`
        return this.http.get<OrganisationChildFinancialCompany>(url, {});
    }

    getOrganisationChildFinancialCompanyDropdownOptions(organisationReference: string) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies/options`
        return this.http.get<DropdownOption[]>(url);
    }

    updateChildFinancialCompany(model: OrganisationChildFinancialCompanyPatch){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies/${model.guid}`
        return this.http.patch<OrganisationChildFinancialCompany>(url, model);
    }

    addChildFinancialCompany(model: OrganisationChildFinancialCompanyPost){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies`
        return this.http.post<OrganisationChildFinancialCompany>(url, model);
    }

    archiveChildFinancialCompany(organisationReference: string, guid: string) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies/${guid}/set-entity-status/${BaseEntityStatuses.ACTIVE_AND_ARCHIVED}`
        return this.http.post<true>(url, {});
    }

    unarchiveChildFinancialCompany(organisationReference: string, guid: string) {
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/child-financial-companies/${guid}/set-entity-status/${BaseEntityStatuses.ACTIVE_NOT_ARCHIVED}`
        return this.http.post<true>(url, {});
    }
}
